import { render } from "./NewStory.vue?vue&type=template&id=6a45ab14&scoped=true"
import script from "./NewStory.vue?vue&type=script&lang=js"
export * from "./NewStory.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a45ab14"

export default script